import React from 'react';

import { CissAutoComplete, CissAutoCompleteProps } from 'components/autocompletes/CissAutoComplete';

export interface EstadoProps {
    idEstado: number;
    dsEstado: string;
    sgEstado: string;
}

type EstadoAutoCompleteProps = Pick<CissAutoCompleteProps, 'label' | 'value' | 'error' | 'multiple' | 'disabled' | 'sx' | 'onChange' | 'name' | 'size'>;

export function EstadoAutoComplete({ value, name, error, label = 'Estado', multiple = false, sx, onChange, size }: EstadoAutoCompleteProps) {
    return (
        <CissAutoComplete
            value={value}
            size={size}
            name={name}
            onChange={onChange}
            sx={sx}
            label={label}
            error={error}
            multiple={multiple}
            selectedStringTemplate="{sgEstado} - {dsEstado}"
            optionStringTemplate="{sgEstado} - {dsEstado}"
            isOptionEqualToValue={(option: EstadoProps, value: EstadoProps) => option.idEstado === value.idEstado}
            requestOptions={{
                url: '/gestao/estado',
                sort: [{ property: 'sgEstado', direction: 'ASC' }],
                columns: 'idEstado,dsEstado,sgEstado',
            }}
        />
    );
}
